<layout>
    <div class="center">
    <div *ngIf="!profile?.uid" class="vert" >
        <label for="email-rte" >Continue as</label>
        <input class='signUpInputs' type='email' name='email-rte' [(ngModel)]="email" >
        <gradient-button (click)="register()">Confirm Email</gradient-button>
    </div>

    

    <div *ngIf="profile?.uid" >
        <h1>Logged in as {{profile?.firstname}}</h1>
    </div>
</div>

    
</layout>